import { render, staticRenderFns } from "./by-sector.vue?vue&type=template&id=04f5cf00&"
import script from "./by-sector.vue?vue&type=script&lang=js&"
export * from "./by-sector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f5cf00')) {
      api.createRecord('04f5cf00', component.options)
    } else {
      api.reload('04f5cf00', component.options)
    }
    module.hot.accept("./by-sector.vue?vue&type=template&id=04f5cf00&", function () {
      api.rerender('04f5cf00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/report/by-sector.vue"
export default component.exports